import { getPath, setPath } from "../settingsRegistry";

/**
 * Zajednička osnova kontrola podešavanja: vrijednost, izmjena i greška za jednu putanju u formi stranice.
 * `local` kontrole (npr. u prozorčiću "Isti rok za sve dane") čitaju i pišu `ctl.ui`, bez praćenja izmjena i provjera.
 */
export default {
  inject: { ctl: "settingsCtl" },
  props: {
    path: { type: String, required: true },
    local: { type: Boolean, default: false },
  },
  computed: {
    value() {
      return this.local ? getPath(this.ctl.ui, this.path) : this.ctl.val(this.path);
    },
    slug() {
      return this.path.replace(/[^a-z0-9_]+/gi, "-");
    },
    isChanged() {
      return !this.local && this.ctl.changed(this.path);
    },
    error() {
      return this.local ? "" : this.ctl.errorText(this.path);
    },
    warning() {
      return this.local ? "" : this.ctl.warnText(this.path);
    },
    flashing() {
      return this.ctl.ui.flash === `sw-${this.slug}` || this.ctl.ui.flash === `f-${this.slug}`;
    },
  },
  methods: {
    write(value, touch = true) {
      if (this.local) {
        setPath(this.ctl.ui, this.path, value, this.$set);
      } else {
        this.ctl.set(this.path, value, touch);
      }
    },
    touch() {
      if (!this.local) {
        this.ctl.touch(this.path);
      }
    },
  },
};
